/************
 * Model Class
 * File Name ...: user-security-group-map.components.ts
 * Generated By : ianday on 7/18/25
 * Date ........: 7/18/25
 /************/
import {ValidationResult} from './validation-result';

export interface UserSecurityGroupMap {
    id: number | null;
    userId: number | null;
    groupId: number | null;
}

export class UserSecurityGroupMap {
    constructor() {
        this.id = 0;
        this.userId = 0;
        this.groupId = 0;
    }
}
